import React from 'react';
import { createPortal } from 'react-dom';

const PortalContainer = ({
  children,
  className = 'modal-root',
  element = 'div',
  isCheckModalOpened = true
}) => {
  const [container] = React.useState(() => {
    const el = document.createElement(element);
    el.classList.add(className);
    return el;
  });

  React.useEffect(() => {
    document.body.appendChild(container);
    let timeout;

    if (isCheckModalOpened)
      timeout = setTimeout(() => document.documentElement.classList.add('is-modal-opened'), 5);

    return () => {
      document.documentElement.classList.remove('is-modal-opened');
      document.body.removeChild(container);
      clearTimeout(timeout);
    };
  }, [container, isCheckModalOpened]);

  return createPortal(children, container);
};

export default PortalContainer;
